import React from "react";
import { ArrowUpRight } from "lucide-react";
import { SectionLabel, SectionHeading } from "./SectionLabel";
import { BRAND_PHOTOS } from "@/config/site";

export default function Leadership() {
  return (
    <section
      id="leadership"
      data-testid="leadership-section"
      className="relative py-24 md:py-32 border-t border-[rgba(198,162,99,0.12)] overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-6">
          <div className="relative rounded-2xl overflow-hidden border border-[rgba(198,162,99,0.18)] aspect-[4/5]">
            <img
              src={BRAND_PHOTOS.notebook}
              alt="Uberti Creative brand notebook and stationery"
              className="absolute inset-0 w-full h-full object-cover"
              style={{ objectPosition: "20% 50%" }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[rgba(0,0,0,0.6)] via-transparent to-transparent" />
          </div>
        </div>

        <div className="lg:col-span-6">
          <SectionLabel number="05" label="Creative Direction" />
          <SectionHeading className="mt-6">
            Built for brands that want to look{" "}
            <span className="italic text-gold-metal">sharper</span>.
          </SectionHeading>
          <p className="mt-8 text-base md:text-lg leading-relaxed text-[rgb(var(--bone-dim))]">
            Creative direction built for brands that want to look sharper, more
            professional, and more consistent online — across every social
            platform, every page, every post.
          </p>
          <p className="mt-6 text-base md:text-lg leading-relaxed text-[rgb(var(--bone-dim))]">
            Every engagement is led personally — content, visuals, and strategy
            shaped with intention, not delegated to a template.
          </p>

          <div className="mt-10 flex flex-wrap gap-3">
            <a
              href="#contact"
              data-testid="leadership-cta"
              className="inline-flex items-center gap-2 px-7 py-4 rounded-full text-sm font-medium btn-gold"
            >
              Book a Consultation
              <ArrowUpRight size={16} />
            </a>
            <a
              href="#services"
              data-testid="leadership-view-services"
              className="inline-flex items-center gap-2 px-7 py-4 rounded-full text-sm font-medium btn-ghost-gold"
            >
              View Services
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
